<template>

    <v-container fluid>
      <v-layout align-start justify-start row fill-height  wrap>

      <v-flex class="pa-1" xs12 sm6 md4>
        <v-card class="elevation-12">
          <v-toolbar dark>
            <v-toolbar-title>{{user.full_name}}</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
                <v-flex xs12 sm12>
                  <p>
                    <b>Логин:</b> {{user.username}}
                  </p>
                </v-flex>

                <v-flex xs12 sm12>
                  <p>
                    <b>E-mail:</b> {{user.email}}
                  </p>
                </v-flex>

                <v-flex xs12 sm12>
                  <p>
                    <b>ОГРН:</b> {{user.department.ogrn}}
                  </p>
                </v-flex>

                <v-flex
                  xs12 sm12>
                  <p>
                    <b>Организация:</b> {{user.department.name_short}}
                  </p>
                </v-flex>
          </v-card-text>
        </v-card>
      </v-flex>

        <v-flex class="pa-1" xs12 sm6 md4>
          <v-card class="elevation-12">
            <v-toolbar dark>
              <v-toolbar-title>Группы</v-toolbar-title>
            </v-toolbar>
            <v-card-text>

              <v-flex xs12 sm12>
                <p
                  v-for="group in user.groups"
                  v-bind:key="group"
                >
                  {{group}}
                </p>
              </v-flex>

            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex class="pa-1" xs12 sm6 md4>
        <v-card class="elevation-12">
          <v-toolbar dark>
            <v-toolbar-title>Организации</v-toolbar-title>
          </v-toolbar>
          <v-card-text>

            <v-flex xs12 sm12>
              <p
                v-for="dependent_department in user.department.dependent_departments"
                v-bind:key="dependent_department.ogrn"
              >
                {{dependent_department.name_short + dif + dependent_department.ogrn}}
              </p>
            </v-flex>

          </v-card-text>
        </v-card>
      </v-flex>

      </v-layout>
    </v-container>

</template>

<script>
export default {
  data () {
    return {
      dif: ' - '
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    user () {
      return this.$store.getters['auth/user']
    }
  }

}
</script>
